<template>
    <div class="basic-experiment">
        <!-- 类型切换：整体图谱 + top5 实体类型 -->
        <div v-if="entityTypeTabs.length" class="type-tabs">
            <el-button
                v-for="tab in typeTabs"
                :key="tab.key"
                type="primary"
                :plain="activeType !== tab.key"
                @click="activeType = tab.key"
            size="small"
            >
                <!-- <i :class="tab.key === 'overall' ? 'el-icon-s-data' : 'el-icon-refresh'"></i> -->
                <span>{{ tab.label }}</span>
            </el-button>
        </div>

        <graph-triple-panel
            :key="activeType"
            :graph-title="currentTitles.graph"
            :table-title="currentTitles.table"
            :graph-data="currentGraph"
            :triples="currentTriples"
            :page-size="10"
        />
    </div>
</template>

<script>
import GraphTriplePanel from './graph_triple_panel.vue';

const OVERALL_TAB = { key: 'overall', label: '整体图谱' };

export default {
    name: 'BasicExperiment',
    components: {
        GraphTriplePanel,
    },
    props: {
        chartData: {
            type: Object,
            default: () => ({ nodes: [], edges: [], triples: [] }),
        },
    },
    data() {
        return {
            activeType: 'overall',
        };
    },
    computed: {
        // top5 实体类型（接口可按排序返回）
        entityTypeTabs() {
            const list = this.chartData.entityTypes || [];
            return list.slice(0, 5).map((item) => ({
                key: item.key,
                label: item.label,
            }));
        },
        typeTabs() {
            return [OVERALL_TAB, ...this.entityTypeTabs];
        },
        activeEntity() {
            if (this.activeType === 'overall') return null;
            return (this.chartData.entityTypes || []).find((item) => item.key === this.activeType) || null;
        },
        currentGraph() {
            if (this.activeType === 'overall') {
                const data = this.chartData;
                return { nodes: data.nodes || [], edges: data.edges || [] };
            }
            const data = this.activeEntity || {};
            // 每个类型固定展示最多 50 个节点
            const nodes = (data.nodes || []).slice(0, 50);
            const nodeIds = new Set(nodes.map((item) => item.id));
            const edges = (data.edges || []).filter(
                (item) => nodeIds.has(item.source) && nodeIds.has(item.target)
            );
            return { nodes, edges };
        },
        currentTriples() {
            if (this.activeType === 'overall') {
                return this.chartData.triples || [];
            }
            return (this.activeEntity && this.activeEntity.triples) || [];
        },
        currentTitles() {
            if (this.activeType === 'overall') {
                return {
                    graph: '整体知识图谱',
                    table: '整体三元组表格',
                };
            }
            const label = (this.activeEntity && this.activeEntity.label) || '实体';
            return {
                graph: `${label}知识图谱`,
                table: `${label}三元组表格`,
            };
        },
    },
};
</script>

<style lang="less" scoped>
.basic-experiment {
    .type-tabs {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 16px;
    }
}
</style>
